import { createContext } from 'react';
export const defaultViewerProps = {
  documentIdOrPath: '',
  renderAppBar: () => null
};
export const ViewerSettingsContext = /*#__PURE__*/createContext(defaultViewerProps);
//# sourceMappingURL=viewer-settings.js.map